import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

import ContentPreview from 'hb-react/shared/components/ContentPreview';

/**
 * @deprecated please use `import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';` instead
 */
const Modal = ({
  children,
  isOpen,
  onClose,
  onOpen,
  size = 'small',
  style,
  title,
  modalPreviewContainerClassNames,
}) => {
  const contentPreview = useRef(null);

  useEffect(() => {
    if (contentPreview.current) {
      if (isOpen) {
        contentPreview.current.portal.openPortal();
      } else {
        contentPreview.current.portal.closePortal();
      }
    }
  }, [isOpen]);

  return (
    <ContentPreview
      ref={contentPreview}
      portalProps={{
        defaultOpen: isOpen,
        onOpen,
        onClose,
        closeOnEsc: true,
      }}
      size={size}
      style={style}
      modalPreviewContainerClassNames={modalPreviewContainerClassNames}
    >
      <div>
        {title && (
          <h4 className="soft--top soft--sides color-gray weight--bold">
            {title}
          </h4>
        )}
        {children}
      </div>
    </ContentPreview>
  );
};

Modal.propTypes = {
  children: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string,
  modalPreviewContainerClassNames: PropTypes.string,
};

export default Modal;
